import { render, staticRenderFns } from "./selectHospital.vue?vue&type=template&id=4a316be6&scoped=true&"
import script from "./selectHospital.vue?vue&type=script&lang=js&"
export * from "./selectHospital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a316be6",
  null
  
)

export default component.exports